import { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import AdminBreadcrumb from '../components/AdminBreadcrumb';
import { RouteNames, adminUserEditPath } from '../components/AppRouter';
import { apiService } from '../services/axios';
import { useAuth } from '../provider/AuthProvider';

function formatDateTime(iso) {
    const date = new Date(iso);

    return Number.isNaN(date.getTime())
        ? iso
        : date.toLocaleString('fr-FR', { dateStyle: 'long', timeStyle: 'short' });
}

function AdminUserPage() {
    const { id } = useParams();
    const { token, isReady } = useAuth();
    const [user, setUser] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [erreur, setErreur] = useState(null);

    useEffect(() => {
        if (!isReady || !token) {
            return undefined;
        }

        let annule = false;
        setIsLoading(true);

        apiService.get(`/api/admin/users/${id}`, isReady, token)
            .then((response) => { if (!annule) setUser(response.data); })
            .catch((error) => {
                if (annule) {
                    return;
                }
                setErreur(error.response?.status === 404
                    ? 'Cet utilisateur n\'existe pas.'
                    : 'Impossible de récupérer cet utilisateur.');
            })
            .finally(() => { if (!annule) setIsLoading(false); });

        return () => { annule = true; };
    }, [id, isReady, token]);

    return (
        <div className="hero-body is-align-items-flex-start">
            <div className="container">
                <AdminBreadcrumb trail={[
                    { libelle: 'Utilisateurs', to: RouteNames.adminUsers },
                    { libelle: user ? user.firstName : `#${id}` },
                ]} />

                {isLoading && <p className="has-text-grey">Chargement…</p>}
                {erreur && <div className="notification is-danger is-light">{erreur}</div>}

                {user && (
                    <>
                        <h1 className="title is-2">{user.firstName}</h1>

                        <table className="table is-fullwidth">
                            <tbody>
                                <tr>
                                    <th style={{ width: '14rem' }}>Email</th>
                                    <td>{user.email}</td>
                                </tr>
                                <tr>
                                    <th>Prénom</th>
                                    <td>{user.firstName}</td>
                                </tr>
                                <tr>
                                    <th>Statut</th>
                                    <td>
                                        <span className={`tag ${user.active ? 'is-success' : 'is-danger'}`}>
                                            {user.active ? 'Actif' : 'Inactif'}
                                        </span>
                                        {!user.active && (
                                            <span className="has-text-grey ml-2">
                                                Ce compte ne peut plus se connecter.
                                            </span>
                                        )}
                                    </td>
                                </tr>
                                <tr>
                                    <th>Super admin</th>
                                    <td>{user.superAdmin ? 'Oui' : 'Non'}</td>
                                </tr>
                                <tr>
                                    <th>Rôles</th>
                                    <td>{user.roles.length > 0 ? user.roles.join(', ') : '—'}</td>
                                </tr>
                                <tr>
                                    <th>Inscrit le</th>
                                    <td>{formatDateTime(user.createdAt)}</td>
                                </tr>
                            </tbody>
                        </table>

                        <div className="buttons">
                            <Link className="button is-dark" to={adminUserEditPath(user.id)}>
                                Éditer
                            </Link>
                            <Link className="button is-light" to={RouteNames.adminUsers}>
                                Retour à la liste
                            </Link>
                        </div>
                    </>
                )}
            </div>
        </div>
    );
}

export default AdminUserPage;
